// when page is loaded for the first time

document.addEventListener("DOMContentLoaded", function () {

    let productInfoSection = document.querySelector("product-info");
  
    let optionsPickerContainer = document.querySelector("#flavors-wrapper");

    let variantDataInputs = optionsPickerContainer.querySelectorAll(
        ".variant-data-input"
    );

    var optionValueWrappers = document.querySelectorAll(
        ".flavor-variant-wrapper"
    );

    // loop over all the variant selectors, weight dropdown and flavours
    optionValueWrappers.forEach(function (optionValueWrapper) {

        let optionContainer = optionValueWrapper.closest(
            ".custom-product-option-container"
        );

        let optionValuesInSameContainer = optionContainer.querySelectorAll(
            ".flavor-variant-wrapper"
        );

        // console.log(optionValueWrapper);

        // when an option is selected, it will update the variants here
        optionValueWrapper.addEventListener("click", function (event) {

            console.log(event.target.tagName)

            if (event.target.tagName != "svg" && event.target.tagName != "path"){
               // console.log(optionValuesInSameContainer)
            // console.log(this)

            optionValuesInSameContainer.forEach(function (optionValue) {
                optionValue.classList.remove("selected");
            });

            this.classList.add("selected");

            let optionName = this.getAttribute("data-option-value");

            // console.log(optionName)            

            // change the image in gallery
            if ($('.thumbnail-list__item button[data-alt="' + optionName + '"]')) {
                $(
                    '.thumbnail-list__item button[data-alt="' + optionName + '"]'
                ).click();
            }

            // console.log($('.thumbnail-list__item button[data-alt="' + optionName + '"]'))

            updateVariants(optionValueWrapper);
            
            updateVariantsFromCart() 

            updateURLForVariant()
                                          
            }            

        });

        updateVariants(optionValueWrapper);

    });


    function updateVariants(optionValueWrapper) {
        let option1Selected = optionsPickerContainer
            .querySelector(".selected[data-option-1]")
            .getAttribute("data-option-value")
            .trim();
        let option2Selected = optionsPickerContainer
            .querySelector(".selected[data-option-2]")
            .getAttribute("data-option-value")
            .trim();
        // console.log(option1Selected);
        // console.log(option2Selected);
        if (optionValueWrapper.hasAttribute("data-option-1")) {
            let relatedVariantInputs = optionsPickerContainer.querySelectorAll(
                `.variant-data-input[data-variant-option-1="${option1Selected}"]`
            );
            // console.log(relatedVariantInputs);
            let options2 = optionsPickerContainer.querySelectorAll(
                `.flavor-variant-wrapper[data-option-2]`
            );
            // console.log(options2);
            // update variants data of all options
            updateVariantDataDependingUponWeight(
                options2,
                relatedVariantInputs,
                option1Selected,
                option2Selected
            );
        } else if (optionValueWrapper.hasAttribute("data-option-2")) {
            let relatedVariantInputs = optionsPickerContainer.querySelectorAll(
                `.variant-data-input[data-variant-option-2="${option2Selected}"]`
            );
            // console.log(relatedVariantInputs);
            let options1 = optionsPickerContainer.querySelectorAll(
                `.flavor-variant-wrapper[data-option-1]`
            );
            // console.log(options1);
            // update variants data of all options
            updateVariantDataDependingUponWeight(
                options1,
                relatedVariantInputs,
                option1Selected,
                option2Selected
            );
        }


        // update price - product price block - start
        let selectedInput = document.querySelector(`.variant-data-input[data-variant-option-1="${option1Selected}"][data-variant-option-2="${option2Selected}"]`)

        let selectedVarinatPriceSale = selectedInput.getAttribute("data-variant-price-sale")
        let selectedVarinatPriceRegular =  selectedInput.getAttribute("data-variant-price-compare");

      
        let priceWrapperEl = productInfoSection.querySelector('.price')
        let saleBadgeEl = productInfoSection.querySelector('.badge.price__badge-sale')
      
        let regulaPriceWrapperEl = productInfoSection.querySelector('.price__regular')
        let onRegularRegularPriceEl = productInfoSection.querySelector('.price__regular .price-item.price-item--regular')
      
        let salePriceWrapperEl = productInfoSection.querySelector('.price__sale')
        let onSaleRegularPriceEl = productInfoSection.querySelector('.price__sale .price-item.price-item--regular')
        let onSaleSalePriceEl = productInfoSection.querySelector('.price__sale .price-item.price-item--sale')

        if (selectedVarinatPriceSale != '' && selectedVarinatPriceRegular != '') {
          priceWrapperEl.classList.add('price--on-sale')
          regulaPriceWrapperEl.style.display = 'none'
          salePriceWrapperEl.style.display = 'inline'
          saleBadgeEl.style.display = 'inline-block'

          onRegularRegularPriceEl.textContent = '';
          
          onSaleRegularPriceEl.textContent = selectedInput.getAttribute("data-variant-price-compare");
          onSaleSalePriceEl.textContent = selectedInput.getAttribute("data-variant-price-sale");

          saleBadgeEl.textContent = selectedInput.getAttribute("data-variant-price-discount");;
        } else {
          priceWrapperEl.classList.remove('price--on-sale')
          salePriceWrapperEl.style.display = 'none'
          regulaPriceWrapperEl.style.display = 'inline'
          saleBadgeEl.style.display = 'none'
          
          onSaleRegularPriceEl.textContent = '';
          onSaleSalePriceEl.textContent = '';
          
          onRegularRegularPriceEl.textContent = selectedInput.getAttribute("data-variant-price-sale");
          
          saleBadgeEl.textContent = selectedInput.getAttribute("data-variant-price-discount");;
        }
        // update price - product price block - end
      
      
    }
    
    updateVariantsFromCart()
    updateURLForVariant()
});

function updateVariantDataDependingUponWeight(
    optionsToBeUpdated,
    relatedVariantInputs,
    option1Selected,
    option2Selected
) {
    for (const optionWr of optionsToBeUpdated) {
        for (const item of relatedVariantInputs) {
            // updating option 1 values
            if (
                item.getAttribute("data-variant-option-2") == option2Selected &&
                item.getAttribute("data-variant-option-1") ==
                optionWr.getAttribute("data-option-value")
            ) {
              
                // updating variant id of div and atc button
                optionWr.setAttribute(
                    "data-variant-id",
                    item.getAttribute("data-variant-id")
                );
                optionWr
                    .querySelector("button.flavor-variant-form-add-button")
                    .setAttribute(
                        "data-variant-id",
                        item.getAttribute("data-variant-id")
                    );
                // updating color
                optionWr.querySelector(".flavor-variant-color").style.background =
                    item.getAttribute("data-variant-color");
                // updating inventory - max
                optionWr
                    .querySelector(".product__variant-selects-input")
                    .setAttribute(
                        "data-max",
                        item.getAttribute("data-variant-max-quantity")
                    );
                optionWr
                    .querySelector(".product__variant-selects-btn--plus")
                    .setAttribute(
                        "data-max",
                        item.getAttribute("data-variant-max-quantity")
                    );
                // updating availablity and atc disable/enabled
                if (item.getAttribute("data-variant-available") == "false") {
                    optionWr.classList.add("variant-unavailable");
                    optionWr
                        .querySelector("button.flavor-variant-form-add-button")
                        ?.setAttribute("disabled", "");
                } else {
                    optionWr.classList.remove("variant-unavailable");
                    optionWr
                        .querySelector("button.flavor-variant-form-add-button")
                        ?.removeAttribute("disabled");
                }
                // console.log('inside -1')
            }
            // updating option 2 values
            if (
                item.getAttribute("data-variant-option-1") == option1Selected &&
                item.getAttribute("data-variant-option-2") ==
                optionWr.getAttribute("data-option-value")
            ) {
                // console.log('inside -2')
              
                // updating variant title
                optionWr.querySelector(".flavor-variant-title").innerHTML =
                    item.getAttribute("data-variant-option-2");
                // updating variant id of div
                optionWr.setAttribute(
                    "data-variant-id",
                    item.getAttribute("data-variant-id")
                );
                // update price
                // console.log(item.getAttribute("data-variant-price-sale"))
                // console.log(item.getAttribute("data-variant-price-compare"))
                // console.log(optionWr.querySelector(".flavor-variant-sale-price"))
                // console.log(optionWr.querySelector(".flavor-variant-compare-at-price"))
                optionWr.querySelector(".flavor-variant-sale-price").innerHTML =
                    item.getAttribute("data-variant-price-sale");
                optionWr.querySelector(".flavor-variant-compare-at-price").innerHTML =
                    item.getAttribute("data-variant-price-compare");
                
              
                // update shakes
                if (item.getAttribute("data-variant-number-of-shakes")) {
                    optionWr.querySelector(".flavor-variant-number-of-shakes").innerHTML =
                        item.getAttribute("data-variant-number-of-shakes");
                } else {
                    optionWr.querySelector(".flavor-variant-number-of-shakes").innerHTML =
                        "";
                }

                // update cost per shake
                console.log(item)
                if (item.getAttribute("data-variant-number-of-shakes")) {
                    optionWr.querySelector(".flavor-variant-cost-per-shake").innerHTML =
                        item.getAttribute("data-variant-cost-per-shake");
                } else {
                    optionWr.querySelector(".flavor-variant-cost-per-shake").innerHTML =
                        "";
                }
              
                // update variant wrapper is sale or regular price 
                if (item.getAttribute("data-variant-price-discount") != '') {
                  // console.log(item.getAttribute("data-variant-price-discount"))
                    optionWr.querySelector('.flavor-variant-info').classList.add('sale-price-item')
                }
                if (item.getAttribute("data-variant-price-discount") == '') {
                  // console.log(item.getAttribute("data-variant-price-discount"))
                    optionWr.querySelector('.flavor-variant-info').classList.add('regular-price-item')
                }
                

                document.querySelector(".selected-display").querySelector('.selected-flavor-variant-wrapper').innerHTML = document.querySelector('.flavor-variant-wrapper.selected').innerHTML;
              
            }
        }
    }
}

const quantityInputs = document.querySelectorAll(".product__variant-selects-input");

quantityInputs.forEach((input) => {

    const plusButton = input.nextElementSibling;

    const minusButton = input.previousElementSibling;

    plusButton.addEventListener("click", function () {
        let currentValue = Number(input.value);
        // console.log(currentValue)
        input.value = currentValue + 1;
        plusButton.setAttribute("disabled",true)
        updateCartVariantQuantity(input,plusButton)
    });

    minusButton.addEventListener("click", function () {
        minusButton.setAttribute("disabled",true)
        let currentValue = Number(input.value);
        if (currentValue > 0) {
            input.value = currentValue - 1;
            updateCartVariantQuantity(input,minusButton);            
        }
        if (input.value == 0){
          input.value = 1;
        }
    });

});

function updateCartVariantQuantity(input,btn) {
    const variantContainer = input.closest(".flavor-variant-form");
    const buttonContainer = input
        .closest(".flavor-variant-form")
        .querySelector(".flavor-variant-form-add-button");
    const quantityContainer = variantContainer.querySelector(
        ".flavor-variant-quantity-wrapper"
    );
    const variantId = input
        .closest(".flavor-variant-form")
        .querySelector(".flavor-variant-form-add-button")
        .getAttribute("data-variant-id");
    const quantity = input.value;

    // Send request to remove variant from cart
    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity, // Set quantity to 0 to remove the variant
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
                        reloadCartDrawer();
                        reloadCartCounter();
                        reloadTotalPrice();
                        cartDrawer.classList.remove("is-empty");
                        // updateVariantsFromCart()
                        btn.removeAttribute("disabled");
                    }
            if (quantity == 0) {
                        buttonContainer.style.display = "flex";
                        quantityContainer.style.display = "none";
                    }
            // console.log(data);
            // Send request to add variant with updated quantity
            // fetch("/cart/add.js", {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //         "X-Requested-With": "XMLHttpRequest",
            //     },
            //     body: JSON.stringify({
            //         id: variantId,
            //         quantity: quantity,
            //     }),
            // })
            //     .then((response) => response.json())
            //     .then((data) => {
            //         // console.log(data);
            //         // debugger;
            //         const cartDrawer = document.querySelector("cart-drawer");
            //         if (quantity == 0) {
            //             buttonContainer.style.display = "flex";
            //             quantityContainer.style.display = "none";
            //         }
            //         if (cartDrawer) {
            //             reloadCartDrawer();
            //             reloadCartCounter();
            //             reloadTotalPrice();
            //             cartDrawer.classList.remove("is-empty");
            //             updateVariantsFromCart()
            //         } else {
            //             console.error("Cart drawer element not found.");
            //         }
            //     })
            //     .catch((error) => {
            //         console.error("Error:", error);
            //     });
        })
        .catch((error) => {
            console.error("Error:", error);
        });
}


const addToCartButtons = document.querySelectorAll(
    ".flavor-variant-form-add-button"
);

addToCartButtons.forEach((button) => {
    button.addEventListener("click", function () {
        const variantContainer = this.closest(".flavor-variant-form");
        // console.log(variantContainer)
        const variantId = button.getAttribute("data-variant-id");
        let quantity = 1;
        if (quantity == 0) {
            quantity = 1;
        }
        addToCart(variantId, quantity, variantContainer, button);
        // updateVariantsFromCart()
    });
});

// $(document).on("click", ".flavor-variant-form-add-button", function () {
//     var button = $(this);
//     const variantId = $(this).data("variant-id");
//     const variantContainer = $(this).parents(".flavor-variant-form");

//     // let quantity = variantContainer.find(".product__variant-selects-input").val();
//     let quantity = 1;
//     addToCart(variantId, quantity, variantContainer, button);
//     updateVariantsFromCart()
// });

function addToCart(variantId, quantity, variantContainer, button) {
    $.ajax({
        url: "/cart/add.js",
        type: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        data: JSON.stringify({
            id: variantId,
            quantity: quantity,
        }),
        dataType: "json",
        success: function (data) {
            // console.log(data);
            const quantityWrapper = $(variantContainer).find(
                ".flavor-variant-quantity-wrapper"
            );
            if (quantityWrapper.length > 0) {
                $(button).hide();
                $(quantityWrapper).css("display", "flex");
            }
            // Add class 'active' to the cart drawer
            const cartDrawer = $("cart-drawer");
            if (cartDrawer.length > 0) {
                reloadCartDrawer();
                reloadCartCounter();
                $(cartDrawer).addClass("active");
                reloadTotalPrice();
                $(cartDrawer).removeClass("is-empty");
                // updateVariantsFromCart()
            } else {
                console.error("Cart drawer element not found.");
            }
        },
        error: function (error) {
            console.error("Error:", error);
        },
    });
}

function reloadCartDrawer() {
    // Use jQuery to reload the cart drawer content
    $("cart-drawer").load(location.href + " #CartDrawer");
}
function reloadCartCounter() {
    // Use jQuery to reload the cart drawer content
    $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
}
function reloadTotalPrice() {
    $("#total_price").load(location.href + " #total_price");
}

// Function to get all variant IDs in the cart
async function updateVariantsFromCart() {
    try {
        const response = await fetch("/cart.js");
        if (!response.ok) {
            throw new Error("Network response was not ok " + response.statusText);
        }
        const cartData = await response.json();
        const variantIds = cartData.items.map((item) => item.variant_id.toString());
        const variantData = cartData.items.map((item) => ({
          "id": item.variant_id.toString(),
          "quantity": item.quantity
        }));
        document.querySelectorAll(".flavor-variant-wrapper-custom").forEach((el) => {
            // console.log(el.getAttribute("data-variant-id"))
            // console.log(variantData)
            if (variantIds.includes(el.getAttribute("data-variant-id"))) {
                el.querySelector(".flavor-variant-form-add-product").setAttribute("style", "display: none;");
                el.querySelector(".flavor-variant-quantity-wrapper").setAttribute("style", "display: flex;");
                el.querySelector(".product__variant-selects-input").value = document.querySelector(`input[data-quantity-variant-id="${el.getAttribute("data-variant-id")}"]`).getAttribute("data-cart-quantity");
                variantData.forEach((dataEl)=>{
                  if (dataEl.id == el.getAttribute("data-variant-id")){
                    el.querySelector(".product__variant-selects-input").value = dataEl.quantity;
                  }
                })
            }
            else if (!variantIds.includes(el.getAttribute("data-variant-id"))) {
                el.querySelector(".flavor-variant-form-add-product").setAttribute("style", "display: flex;");
                el.querySelector(".flavor-variant-form-add-product").firstElementChild.setAttribute("style", "display: block;");
                el.querySelector(".flavor-variant-quantity-wrapper").setAttribute("style", "display: none;");
            }
        })
    } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
    }
}

// Call the function to get the variant IDs
// updateVariantsFromCart();

function updateURLForVariant() {
    const url = new URL(window.location);
    url.searchParams.set('variant', document.querySelector(".flavor-variant-wrapper-custom.selected").getAttribute("data-variant-id"));
    window.history.replaceState({}, '', url);
}